import React from 'react';
import {
  Box,
  Card,
  CardContent,
  LinearProgress,
  Typography,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface RatingComparisonProps {
  userRating: number;
  competitorRating: number;
}

const RatingComparison: React.FC<RatingComparisonProps> = ({
  userRating,
  competitorRating,
}) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Typography variant="h6">Rating Analysis</Typography>
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Box display="flex" alignItems="center">
          <StarIcon color="secondary" />
          <Typography ml={1}>Your Rating: {userRating.toFixed(1)}</Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <StarIcon color="disabled" />
          <Typography ml={1}>
            Competition Avg.: {competitorRating.toFixed(1)}
          </Typography>
        </Box>
      </Box>
      <LinearProgress
        variant="determinate"
        color="secondary"
        value={(competitorRating / 5) * 100}
        sx={{ mt: 2 }}
      />
    </CardContent>
  </Card>
);

export { RatingComparison };
